import { validate as uuidValidate, version as uuidVersion } from 'uuid';

export const classNames = (...classes) => classes.filter(Boolean).join(' ');
export const getUserFullName = ({
	firstName,
	first_name,
	last_name,
	lastName,
	email,
} = {}) => {
	const fn = firstName || first_name || '';
	const ln = lastName || last_name || '';

	return fn || ln
		? `${fn}${fn ? ` ${ln}` : ln}`
		: fn || ln || email || 'Unknown';
};

export const pluralize = (length, single, plural) =>
	length === 1 ? single : plural;

export const getBannerHealth = (
	locationHealth,
	assetsHealth = [],
	childrensHealth = []
) => {
	if (locationHealth === 'outage') {
		return 'locationOutage';
	}

	if (locationHealth === 'disruption') {
		return 'locationDisruption';
	}

	const assetHealthData = [...assetsHealth, ...childrensHealth].reduce(
		(a, c) => {
			a.total++;
			a[c]++;

			return a;
		},
		{
			operational: 0,
			caution: 0,
			down: 0,
			partialDisruption: 0,
			completeDisruption: 0,
			locationDisruption: 0,
			partialOutage: 0,
			completeOutage: 0,
			locationOutage: 0,
			total: 0,
		}
	);

	if (assetHealthData.total) {
		if (
			assetHealthData.down ||
			assetHealthData.partialOutage ||
			assetHealthData.completeOutage ||
			assetHealthData.locationOutage
		) {
			if (
				assetHealthData.total ===
				assetHealthData.down +
					assetHealthData.partialOutage +
					assetHealthData.completeOutage +
					assetHealthData.locationOutage
			) {
				return 'completeOutage';
			}
			return 'partialOutage';
		} else if (
			assetHealthData.caution ||
			assetHealthData.partialDisruption ||
			assetHealthData.completeDisruption ||
			assetHealthData.locationDisruption
		) {
			if (
				assetHealthData.total ===
				assetHealthData.caution +
					assetHealthData.partialDisruption +
					assetHealthData.completeDisruption +
					assetHealthData.locationDisruption
			) {
				return 'completeDisruption';
			}
			return 'partialDisruption';
		}
	}
	return 'operational';
};

export const toLowerValue = (str) => str.replace(/\s+/g, '-').toLowerCase();

export const createDataTree = (dataset = [], childKey = 'children') => {
	const hashTable = Object.create(null);
	(dataset || []).forEach(
		(aData) =>
			(hashTable[aData.id] = {
				...aData,
				key: aData.name,
				count: 0,
				depth: 0,
				label: aData.name?.toLowerCase(),
				[childKey]: [],
			})
	);
	const dataTree = [];
	(dataset || []).forEach((aData) => {
		if (aData.parent_id) {
			hashTable[aData.parent_id][childKey].push(hashTable[aData.id]);
		} else {
			dataTree.push(hashTable[aData.id]);
		}
	});

	function addDepth(arr, key, depth = 0) {
		arr?.forEach((obj) => {
			obj.depth = depth;
			addDepth(obj[key], key, depth + 1);
		});
	}

	addDepth(dataTree, childKey);

	return dataTree;
};

export const capitalizeFirstLetter = (string) =>
	string?.charAt(0).toUpperCase() + string?.slice(1);

export const getStandardAssetName = ({
	manufacturerName,
	modelName,
	serialNumber,
	location,
	manufacturer,
	model,
}) =>
	`${manufacturerName || manufacturer?.name} ${
		modelName || model?.name
	} (S/N: ${serialNumber})${location?.name ? ` in ${location?.name}` : ''}`;

export const validateUUID = (string, version = 4) => {
	return uuidValidate(string) && uuidVersion(string) === 4;
};

export const getArrayPosition = (arr, pos) =>
	arr.length && arr.length >= pos && arr[pos - 1];

export const getReduced = (statuses, key) =>
	statuses.reduce((a, c) => {
		const status = c[key];

		if (a[status]) {
			a[status].push(c);
		} else {
			a[status] = [c];
		}

		return a;
	}, {});

export const objectAccess = (path, object) => {
	if (!object) return '';

	const resolvePath = (p) => {
		return p.split('.').reduce((o, i) => {
			return o && o[i] !== undefined && o[i] !== null ? o[i] : '';
		}, object);
	};

	if (Array.isArray(path)) {
		for (const p of path) {
			const result = resolvePath(p);
			if (result !== '') return result;
		}
		return '';
	}

	if (typeof path === 'string') {
		return resolvePath(path);
	}

	return object?.value || '';
};
